import { CircularProgress } from "@mui/material";
import { FC } from "react";

import { AppBootstrapLoaderStyled } from "./app-bootstrap-loader.styled";

interface IAppBootstrapLoaderProps {
  isVisible?: boolean;
  shouldLeaveLeftBar?: boolean;
}

export const AppBootstrapLoader: FC<IAppBootstrapLoaderProps> = ({
  isVisible = true,
  shouldLeaveLeftBar = false,
}) => {
  return (
    <AppBootstrapLoaderStyled
      $isVisible={isVisible}
      $shouldLeaveLeftBar={shouldLeaveLeftBar}
      aria-busy={isVisible}
      aria-hidden={!isVisible}
      aria-live="polite"
      role="status"
    >
      <CircularProgress color="primary" disableShrink size={80} thickness={4} />
    </AppBootstrapLoaderStyled>
  );
};
